import classNames from "classnames";
import Tooltip from "PFComponents/tooltip/tooltip";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import PropTypes from "prop-types";
import React from "react";

import css from "./scroll_bar.module.scss";

interface Props {
  kind: "left" | "right";
  onMouseDown: (e: React.SyntheticEvent<EventTarget>) => void;
  isDragged: boolean;
  value: string;
}

const ThumbEdge = ({ kind, onMouseDown, isDragged, value }: Props) => {
  const { utc, formatDate } = useDateFormatter();

  {
    /* eslint-disable jsx-a11y/no-static-element-interactions */
  }
  return (
    <Tooltip
      className={css.tooltip}
      content={formatDate(utc(value))}
      placement={kind}
      visible={isDragged}
      arrow={false}
      enableVisible
    >
      <div
        className={classNames(css.edge, css[kind], { [css.dragging]: isDragged })}
        onMouseDown={onMouseDown}
      >
        <div className={css.edgeBar} />
        <div className={css.edgeBar} />
      </div>
    </Tooltip>
  );
};

ThumbEdge.propTypes = {
  kind: PropTypes.oneOf(["left", "right"]).isRequired,
  onMouseDown: PropTypes.func.isRequired,
  isDragged: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired
};

export default ThumbEdge;
